/* tslint:disable:max-line-length */
/**
 * 1
 * Alza API 1
 * Alza Rest Api Swagger Documentation
 *   "path": null
 */

import * as model from '../model'

/** Conversation Model V1 */
export interface ConversationV1 {
  /** Conversation Messages */
  messages: model.MessagesSubsectionV1
  /** Conversation Assigned Vendor User */
  assignee?: model.ActionUserV1
  /** Vendor Team Id */
  vendorTeam: model.VendorLimitedV1
  /** Last Message of Conversation */
  lastMessage?: model.MessageV1
  /**
   * Conversation Identification - Used For Messaging Purposes
   * format: uuid
   */
  id: string
  /** Date of Covnersation Creation */
  started: string
  /**
   * Conversation State Options: [1 = New, 2 = Open, 3 = Assigned, 4 = Closed]
   * format: int32
   */
  conversationState: ConversationStateConversationV1Enum
  /** Conversation Is Closed */
  isClosed: boolean
  meta?: model.MetaInfo
}

export enum ConversationStateConversationV1Enum {
  New = 1,
  Open = 2,
  Assigned = 3,
  Closed = 4,
}



// WEBPACK FOOTER //
// ./src/app/api/api/models/conversation-v1.ts